'use client';

import ServiceUnavailable from '@/common/components/ServiceUnavailable';

export default function UIError() {
  return <ServiceUnavailable fullScreen />;
}
